module.exports = __webpack_public_path__ + "img/bg_main.6c4e5ef2.png";